import applelogo from '../assets/applelogo.png';
import googleplay from '../assets/googleplay.png';
import { APP_STORE_URL, PLAY_STORE_URL } from '../config';

// Botões de baixar o app (App Store / Google Play) — mesmo modelo do UEN: um
// cartão com o logo da loja + "Baixar na / App Store". Tema-aware (tokens --p-*),
// então funciona no claro e no escuro. As URLs vêm do config (config.js).

const btnBase = {
    display: 'flex', width: '100%', alignItems: 'center', gap: 12,
    background: 'var(--p-surface, #fff)', border: '1px solid var(--p-border, #e2e8f0)',
    borderRadius: 14, padding: '10px 16px', boxShadow: 'var(--p-shadow-sm, 0 4px 10px rgba(0,0,0,.1))',
    cursor: 'pointer', boxSizing: 'border-box', transition: 'box-shadow .18s, transform .18s',
};
const logoStyle = { width: 26, height: 26, objectFit: 'contain', display: 'block', flexShrink: 0 };
const textWrap = { display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.15, minWidth: 0 };
const topLabel = { fontSize: 10, fontWeight: 500, color: 'var(--p-text-muted, #6b7280)', letterSpacing: '.6px', textTransform: 'uppercase' };
const storeName = { fontSize: 17, fontWeight: 700, color: 'var(--p-text, #1f2937)', marginTop: 1 };

const onEnter = (e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = 'var(--p-shadow-md, 0 6px 16px rgba(0,0,0,.16))'; };
const onLeave = (e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'var(--p-shadow-sm, 0 4px 10px rgba(0,0,0,.1))'; };

function StoreButton({ logo, alt, top, name, url, ariaLabel }) {
    return (
        <button
            type="button"
            onClick={() => url && window.open(url, '_blank', 'noopener')}
            style={btnBase}
            onMouseEnter={onEnter}
            onMouseLeave={onLeave}
            aria-label={ariaLabel}
        >
            <img src={logo} alt={alt} style={logoStyle} />
            <span style={textWrap}>
                <span style={topLabel}>{top}</span>
                <span style={storeName}>{name}</span>
            </span>
        </button>
    );
}

export function AppleStoreButton() {
    return (
        <StoreButton logo={applelogo} alt="App Store" top="Baixar na" name="App Store"
            url={APP_STORE_URL} ariaLabel="Baixe o app da UEB na App Store" />
    );
}

export function GooglePlayButton() {
    return (
        <StoreButton logo={googleplay} alt="Google Play" top="Disponível no" name="Google Play"
            url={PLAY_STORE_URL} ariaLabel="Baixe o app da UEB no Google Play" />
    );
}
